var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 19.4509V30.8497C38.0001 32.0119 37.5554 33.1301 36.7573 33.9749C35.9591 34.8196 34.8679 35.3269 33.7076 35.3927L33.45 35.3997H14.55C13.3878 35.3998 12.2696 34.9552 11.4249 34.157C10.5801 33.3588 10.0728 32.2677 10.007 31.1073L10 30.8497V19.4509L23.5128 26.5293C23.6631 26.6081 23.8303 26.6492 24 26.6492C24.1697 26.6492 24.3369 26.6081 24.4872 26.5293L38 19.4509Z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5501 13H33.4501C34.5779 12.9999 35.6655 13.4186 36.5021 14.175C37.3387 14.9314 37.8645 15.9715 37.9777 17.0936L24.0001 24.4156L10.0225 17.0936C10.131 16.016 10.6203 15.0125 11.4025 14.2634C12.1847 13.5144 13.2084 13.0689 14.2897 13.007L14.5501 13H33.4501H14.5501Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.47f9a9a730f8f4281bd1af692cf8db84.svg";
export { ForwardRef as ReactComponent };